import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { handleLoadingAndErrorState } from "#/redux/util/reduxUtils";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/rod_knj/knjiga";

export const getPedigreeBookEntryPage = createAsyncThunk(
  "pedigree/entries/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/vpis/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getPedigreeBookById = createAsyncThunk(
  "pedigree/byId",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/vpis/page`,
        null,
        page,
        filter,
        sort
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updatePedigreeBookEntry = createAsyncThunk(
  "pedigree/update",
  async ({ id, pedigreeEntry }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(
        `${baseUrl}/vpis/${id}`,
        pedigreeEntry
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const thunks = [
  getPedigreeBookById,
  getPedigreeBookEntryPage,
  updatePedigreeBookEntry,
];

const pedigreeSlice = createSlice({
  name: "pedigree",
  initialState: {
    page: {},
    isLoading: false,
    error: null,
    pedigreeEntry: null,
    byAnimalId: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPedigreeBookEntryPage.fulfilled, (state, action) => {
        state.page = action.payload;
        action.payload?.content?.forEach((pedigreeEntry) => {
          const animalId = pedigreeEntry.zival?.id;
          if (animalId != null) {
            state.byAnimalId[animalId] = pedigreeEntry;
          }
        });
      })
      .addCase(updatePedigreeBookEntry.fulfilled, (state, action) => {
        state.pedigreeEntry = action.payload;
      });

    handleLoadingAndErrorState(builder, thunks);
  },
});

export default pedigreeSlice.reducer;
